import React, {useEffect, useState} from "react";
import Styles from './styles.module.scss'
import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import LaunchpadPower from "../../components/launchpadPower";
import LaunchpadLeague from "../../components/launchpadLeague";
import LaunchpadProjects from "../../components/launchpadProjects";
import LaunchpadProjectsAll from "../../components/launchpadProjectsAll";
import {useDispatch, useSelector} from "react-redux";
import {getLatestNews} from "../../store/main/action";
import LaunchpadNews from "../../components/launchpadNews";
import {useNavigate} from "react-router-dom";
import {
    getLaunchpadMain,
    getLaunchpadStatuses,
    getProjectsLast,
    getUserProjects
} from "../../store/cabinet/action";
import LaunchpadStakeModal from "../../components/launchpadStakeModal";
import FreezeOmtHoneeModal from "../../components/freezeOmtHoneeModal";



const LaunchpadPage = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);
    const userData = useSelector(store => store.cabinet.userData);

    const [currentValueId, setCurrentValueId] = useState(1);

    const token = Number(userData?.user?.token_freezed_amount ?? 0);
    const index = Number(userData?.user?.index_freezed_amount ?? 0);

    useEffect(() => {
        const nextId = (token === 0 && index > 0) ? 2 : 1;
        setCurrentValueId(nextId);
    }, [token, index]);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-up');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        dispatch(getLatestNews());
        dispatch(getLaunchpadStatuses());
        dispatch(getUserProjects());
        dispatch(getProjectsLast(11));
        dispatch(getLaunchpadMain());
    },[dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Кабинет')}/>
            <LaunchpadLeague currentValueId={currentValueId}/>
            <LaunchpadPower currentValueId={currentValueId} setCurrentValueId={setCurrentValueId}/>
            <LaunchpadProjects/>
            <LaunchpadProjectsAll/>
            <LaunchpadNews/>
            <LaunchpadStakeModal/>
            <FreezeOmtHoneeModal/>
        </section>
    );
};

export default LaunchpadPage;